<template>
    <b-modal
        id="school-settings-add-category"
        :ok-title="$t('common.save')"
        @ok="onSubmit($event)"
        @show="onShow"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :title="$t('school.new_category')"
        autocomplete="off"
        modal-class="apprentice-default-modal">
        <div>
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    :key="index"
                    show
                    variant="danger">
                    {{ error.message }}
                </b-alert>
            </div>
            <div class="title-and-color">
                <b-form-group
                    class="title-form-group"
                    :label="$t('common.title')"
                    label-for="profile-category-title-input">
                    <b-form-input
                        id="profile-category-title-input"
                        v-model="title"
                        :placeholder="$t('school.give_a_title')"
                        type="text"></b-form-input>
                </b-form-group>

                <b-form-group
                    class="color-form-group"
                    :label="$t('common.colour')"
                    label-for="color-picker-input">
                    <design-2021-colorpicker
                        id="profile-category-color-input"
                        :color="color"
                        @on-close="changeColor"></design-2021-colorpicker>
                </b-form-group>
            </div>

            <div class="description">
                <b-form-group
                    :label="$t('common.description')"
                    label-for="profile-category-description-input">
                    <ckeditor
                        id="profile-category-description-input"
                        v-model="description"
                        :editor="editor"
                        :config="editorConfig">
                    </ckeditor>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';
import { ords } from '../../../../app';

export default {
    name: 'design-2021-school-settings-profile-categories-add-modal-component',
    data() {
        return {
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                placeholder: this.$t('common.description'),
                toolbar: {
                    items: [
                        'heading',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            title: '',
            color: '#ffffff',
            description: '',
            hasError: false,
            errors: {
                title: {
                    error: false,
                    message: this.$t('school.title_field_cannot_be_empty'),
                },
                color: {
                    error: false,
                    message: this.$t('school.no_colour_value_is_specified'),
                },
            },
        };
    },

    methods: {
        onSubmit(event) {
            if (this.foundError()) {
                event.preventDefault();
                return;
            }

            let data = {
                title: this.title,
                color: this.color,
                description: this.description,
            };

            this.alert.saving();

            this.axios.post(this.routes.profileCategoryAdd(), data).then(
                (response) => {
                    ords.use('profileCategory').add(response.data);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.title = '';
            this.color = '#ffffff';
            this.description = '';
            this.clearError();
        },

        changeColor(color) {
            this.color = color;
        },

        foundError() {
            this.clearError();

            if (this.title === '') {
                this.hasError = true;
                this.errors.title.error = true;
            }

            if (this.color === '') {
                this.hasError = true;
                this.errors.color.error = true;
            }

            return this.hasError;
        },

        clearError() {
            this.hasError = false;
            this.errors.title.error = false;
            this.errors.color.error = false;
        },
    },
};
</script>

<style scoped lang="scss">
.title-and-color {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    input {
        margin-bottom: 0;
    }

    .title-form-group,
    .color-form-group {
        width: 100%;
    }

    .color-picker ::v-deep {
        .color-picker-container {
            height: initial !important;

            .current-color {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-top-right-radius: $border-radius-content;
                border-bottom-right-radius: $border-radius-content;
            }

            i {
                display: flex;
                height: 100% !important;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .title-and-color {
        flex-direction: row;
        justify-content: space-between;

        .title-form-group {
            width: calc(73% - 15px);
        }

        .color-form-group {
            width: 27%;
        }
    }
}
</style>
